import type { FC } from 'react'
import React, { useCallback } from 'react'

import ListItem from './list-item'
import type { ListItemProps } from './types'
import Checkbox from '../checkbox/checkbox'
import type { CheckboxProps } from '../checkbox/types'

const StandardCheckListItem: FC<
  Omit<ListItemProps<HTMLLIElement>, 'children'> &
    Pick<CheckboxProps, 'checked' | 'label'>
> = props => {
  const { variant, checked, label, ...rest } = props

  const handleCheckBoxClick = useCallback(
    (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => e.preventDefault(),
    []
  )
  // eslint-disable-next-line no-console
  // console.log('--- render @costar/theme-ui StandardCheckListItem -----')
  return (
    <ListItem height="2em" {...rest}>
      <Checkbox
        {...{
          variant,
          checked,
          label,
          onClick: handleCheckBoxClick
        }}
      />
    </ListItem>
  )
}

export default React.memo(StandardCheckListItem)
